import {Injectable} from "@angular/core";
import {SunfishApi} from "../../shared/sdk/services/custom";
import {Observable} from "rxjs";
import {Storage} from "@ionic/storage";

@Injectable()
export class AbswReportBloc {
  constructor(
    private sunfishApi: SunfishApi,
    private storage: Storage,
  ) {
  }

  getUserData(): Observable<any> {
    return this.sunfishApi.getUserData();
  }

  async getSFGoAuth(): Promise<any> {
    return JSON.parse(await this.storage.get('SFGoAuth'));
  }
}



// WEBPACK FOOTER //
// ./src/bloc/report/absw-report.bloc.ts